<template>
  <div style="margin-top: 135px">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import quotationDlg from "./../project/model/quotation";
export default {
  name: "HomeView",
  components: { quotationDlg },
  methods: {
    clickQuotation() {
      this.$refs.quotationDlg.show();
    },
    test() {
      const url = this.$router.resolve({
        path: "/accessoriyDetail",
        // query: { selected: "2" },
      });
      window.open(url.href, "_blank");
    },
    to_forkliftList() {
      this.$router.push({
        path: "/forkliftList",
      });
    },
    to_accessoriyList() {
      this.$router.push({
        path: "/accessoriyList",
      });
    },
  },
};
</script>
